import { useRef, useEffect } from '@digsup/core-ui';
import { useFormikContext } from 'formik';

export const useFocusOnError = ({ fieldRef, name }) => {
  const formik = useFormikContext();
  const prevSubmitCountRef = useRef(formik.submitCount);
  const firstErrorKey = Object.keys(formik.errors)[0];
  useEffect(() => {
    if (prevSubmitCountRef.current !== formik.submitCount && !formik.isValid) {
      if (fieldRef.current && firstErrorKey === name) {
        // eslint-disable-next-line no-unused-expressions
        fieldRef?.current?.focus?.();
      }
      prevSubmitCountRef.current = formik.submitCount;
    }
  }, [formik.submitCount, formik.isValid, firstErrorKey]);
};
